// src/constants/sessionSettings.js

export const BUZZER_SESSION_LENGTHS = [
  5,
  10,
  15,
  20,
  30,
];

export const STUDY_SESSION_LENGTHS = [
  5,
  10,
  20,
  30,
  50,
];

export const DEFAULT_BUZZER_SESSION_LENGTH = 5;
export const DEFAULT_STUDY_SESSION_LENGTH = 10;